























































import { Component, Prop, Mixins } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import UtilMixin from "@/mixins/utilMixin";
import SearchBase from "@/components/admin_common/SearchBase.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { PortalOfficeReview } from "@/model/portal";
import { PORTAL_OFFICE_REVIEW_IS_OPEN } from "@/consts/portal";

@Component({
  components: {
    AppTextField,
    SearchBase,
    AppAuthButton,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin) {
  private searchKey = ""; //絞り込み文字列

  private PORTAL_OFFICE_REVIEW_IS_OPEN = PORTAL_OFFICE_REVIEW_IS_OPEN;

  /** 口コミ情報 */
  @Prop({
    type: Array,
    default: () => [],
  })
  readonly items!: PortalOfficeReview[];

  private headers = [
    { text: "詳細", value: "action" },
    { text: "事業所番号（HST）", value: "hst_no" },
    { text: "事業所名", value: "portal_office_name" },
    { text: "応募者番号（JST）", value: "jst_no" },
    { text: "応募者名", value: "recruitee_name" },
    { text: "評価点数", value: "rating_avg" },
    { text: "公開・非公開", value: "is_open" },
  ];

  /** 詳細ボタンクリック時 */
  private goDetail(id: number) {
    /** 詳細画面へ遷移 */
    this.$router.push({ path: `/jobsearch/portal-office-review/detail/${id}` });
  }
}
